





























































































































import {Component} from 'vue-property-decorator';
import {Getter} from "vuex-class";
import GenericDistribution from '@/pages/Pages/Distributions/GenericDistribution.vue'
import CallTemplate from '@/pages/Pages/Templates/CallTemplate.vue'
import {declOfNum} from '@/utils/data-helper'
import { MsgTransports } from '@/store/types';

@Component({components: {GenericDistribution, CallTemplate}})
export default class CallDistribution extends GenericDistribution {
  @Getter("callSounds") callSoundsList: any;
  @Getter("ivrMenu") ivrMenuList: any;

  transport = MsgTransports.CALL

  get getIvrMenuName() {
    return this.ivrMenuList.find((item: any) => item.id == this.template.message)?.name
  }

  get getFile() {
    const file =  this.callSoundsList.find((item: any) => item.fileId == this.template.message)
    return file ?? {name: '', patch: ''}
  }

  get repeatMessage() {
    return this.templateRef?.is_repeat
      ? this.$t('distribution.call.count') + declOfNum(this.template.maxRepeatCount, this.$t('declensions.times').toString().split('/'))
        + ' ' + this.$t('distribution.call.dtmf') + ' ' + this.template.repeatDtmf
      : this.$t('forbidden')
  }

  get redirectMessage() {
    let res = this.$t('absent')
    if (this.templateRef?.is_redirect) {
      res = this.$t('distribution.call.redirect') + this.template.redirectNumber + ' '
      res += this.template.callRedirectDtmf
        ? this.$t('distribution.call.dtmf') + ' ' + this.template.callRedirectDtmf
        : this.$t('distribution.call.redirectBeep')
    }
    return res
  }

  get templateMessage() {
    let res = this.$t('values.active.no')
    if (this.templateRef?.is_sms) {
      res = this.$t('distribution.call.smsTemplate') + this.templateName + ' '
      res += this.template.sendSmsDtmf
        ? this.$t('distribution.call.dtmf') + ' ' + this.template.sendSmsDtmf
        : this.$t('distribution.call.sendSmsEnd')
    }
    return res
  }

  get templateName() {
    return this.templateRef?.smsTemplatesList.find((item:any) => item.templateId == this.template.smsTemplateId)?.name
  }

  get retryMessage() {
    return this.template.maxRetryCount
      ? this.$t('distribution.call.retry') + ' ' + this.$t('distribution.call.count') + declOfNum(this.template.maxRetryCount, this.$t('declensions.times').toString().split('/'))
      : this.$t('values.active.no')
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    this.beforeLeave(to,from,next)
  }
}
